<template>
  <w-flex wrap class="justify-space-between">
    <div class="xs8 headline text-left pl7 monitoring-title">
      <span>
        <!-- otherwise the anchor element would wrap the icon incrrectly -->
        <router-link :to=optionsStore.state.navigation.prewView class="back-link">
          <w-icon class="v-middle" fill-height color="primary">
            mdi mdi-arrow-left
          </w-icon>
        </router-link>
      </span>
      <span> Monitoring Base Station</span> 
      
    </div>
    <w-flex v-if="manual_refresh_enabled" wrap class="align-center mx3">
      <div class="spacer"></div>
      <span class="center pya mx2">Last Refresh:
        {{
          stationStore.state.lastRefresh
            ? timeformatLoc(
              Math.floor(stationStore.state.lastRefresh.getTime() / 1000),
              optionsStore.getState.localeBrowser,
              optionsStore.getState.timezoneBrowser
            )
            : stationStore.state.lastRefresh
        }}
      </span>
      <w-button class="mx5" lg @click="refresh()">Refresh</w-button>
    </w-flex>
  </w-flex>
  <template v-if="isMounted">
    <w-flex wrap md class="smd-column xs12 pl7 px6 title3 d-flex">
      <!--populate object with param values-->
      <div column class="xs4 smd-fill-width text-left fill-height pa3 justify-space-between">
        <!-- OTHER STATS -->
        <w-flex v-for="item in otherStats" :key="item.label">
          <w-flex v-if="item.label =='Thing'" class="pxa fill-width pb2 fill-height">
              <router-link class="d-flex fill-width" :to="'/things/All?filterID=' + item.value">
              <w-icon md class="mb2"> {{ icon ? icon : "mdi mdi-arrow-up-left" }} </w-icon>     
            <span class="text-bold">{{ item.label }}: &ensp;</span><br />
            <span v-if="!item.object">{{ item.value }}</span>
          </router-link>
          </w-flex>
          <w-flex v-else class="pxa fill-width pb2 fill-height">
            <span class="text-bold">{{ item.label }}: &ensp;</span><br />
            <span v-if="!item.object">{{ item.value }}</span>
          </w-flex>
        </w-flex>
        <w-flex wrap class="align-center">
          <!-- Change Installer component  -->
          <w-button v-if="store.currentUser.roles.includes('ADMIN')" class="mb2" lg @click="overlay.show = true">Change
            Installer</w-button>
          <w-overlay v-model="overlay.show" :persistent="persistent" :persistent-no-animation="persistentNoAnimation"
            :opacity="opacity">
            <w-card class="overlays center ma3">
              <span class="top">
                <w-icon @click="overlay.show = false" class="icon-button right">mdi
                  mdi-close</w-icon>
              </span>
              <w-alert class="error mt2" v-if="overlay.error">{{ overlay.error.message }}</w-alert>
              <w-form v-model="overlay.valid" @submit="() => overlay.valid ? changeInstaller(userId) : null">
                <w-input v-model="userId" @keyup="overlay.error = null" class="ma2" label="New Installer"
                  :validators="[validators.required, validators.number]" placeholder="User Id es: 1234 " />
                <w-button class="ma1 overlay-confirm" bg-color="primary" lg type="submit"
                  :disabled="overlay.valid === false" :loading="overlay.submitted && !form.sent">
                  <w-icon class="mr1">wi-check</w-icon>
                  Change
                </w-button>
              </w-form>
            </w-card>
          </w-overlay>
        </w-flex>

              <!-- LABEL GROUPS SEPARATE BLOCK -->
        <w-flex
  v-if="labelGroups.some(g => g.value && g.value.trim())"
  class="wrap my2"
  column
>
  <span class="text-bold mb2">Label Groups:</span>
  <w-flex wrap>
    <template v-for="(item, index) in labelGroups" :key="index">
      <w-tag
        v-for="(label, i) in item.value.split(',')"
        :key="`${index}-${i}`"
        class="button pa2 mx2 my1"
        :model-value="label"
        :bg-color="label === selectedLabel ? 'primary-light2' : 'primary'"
        @click="loadLabelGroup(label)"
        dark
        lg
      >
        {{ label }}
      </w-tag>
    </template>
  </w-flex>
</w-flex>

      <!-- ═══ STATI ANTENNA: 3 dimensioni ═══ -->
      <div class="stati-card">
        <div class="stati-card__header">
          <span class="text-bold">Stati Antenna</span>
        </div>
        <div class="stati-card__body">

          <!-- DIM 1: NTRIP -->
          <div class="stato-row">
            <span class="stato-dim">
              <w-icon sm class="mr1">mdi mdi-antenna</w-icon>
              <span>NTRIP</span>
              <state-info :alignment="'left'" :infos="statusInfoBaseStation()" class="stati-card__info-icon" />
            </span>
            <span :class="'stato-badge px2 ' + ntripStateInfo.class">
              {{ ntripStateInfo.name }}
            </span>
          </div>

          <hr class="stato-sep" />

          <!-- DIM 2: Funzionamento (georef) -->
          <div class="stato-row">
            <span class="stato-dim">
              <w-icon sm class="mr1">mdi mdi-crosshairs-gps</w-icon>
              <span>Funzionamento</span>
              <state-info :alignment="'left'" :infos="statusInfoGeoref()" class="stati-card__info-icon" />
            </span>
            <span :class="'stato-badge px2 ' + georefStateInfo.class">
              {{ georefStateInfo.name }}
            </span>
          </div>

          <!-- DIM 3: Firmware -->
          <template v-if="stationStore.state.firmwareInfo">
            <hr class="stato-sep" />
            <div class="stato-row">
              <span class="stato-dim">
                <w-icon sm class="mr1">mdi mdi-chip</w-icon>
                <span>Firmware</span>
              </span>
              <div class="firmware-version-block">
                <span v-if="firmwareStateInfo" :class="'stato-badge px2 ' + firmwareStateInfo.class">
                  {{ firmwareStateInfo.name }}
                  <span v-if="firmwareVersion&&stationStore.state.firmwareInfo?.state !== 'ERROR'" class="ml1">v{{ firmwareVersion }}</span>
                </span>
                <span v-if="firmwareError" alt={{ firmwareError }} class="firmware-error-msg">{{ firmwareError }}</span>
                <span v-if="firmwareExpectedVersion" class="firmware-expected">
                  Expected: <strong>v{{ firmwareExpectedVersion }}</strong>
                </span>
                <span v-else-if="stationStore.state.firmwareInfo?.state === 'AUTO_UPDATE_DISABLED'" class="firmware-expected-disabled">
                  Expected: disabled
                </span>
                <span v-else class="firmware-expected-unknown">
                  Expected: unknown
                </span>
              </div>
            </div>
          </template>

        </div>
      </div>
      <!-- ════════════════════════════════════ -->

      <div v-if="stationStore.state.simDetails && !stationStore.state.simDetailsError">
        <w-flex v-for="item in stationStore.state.simDetails" :key="item.label"> <w-flex
            class="pxa fill-width pb2 fill-height" v-if="item.value != null && item.value != ''">
            <span class="text-bold">{{ item.label }}: &ensp;</span><br />
            <!-- <div class="spacer"></div> -->
            <span class="" v-if="!item.object">
              {{ item.value }}
            </span></w-flex>
        </w-flex>
      </div>
      <div v-else class="my3 pa3 text-center red-light5--bg">
        <span>
          <!-- Error retriving sim details {{ stationStore.state.simDetailsError }} -->
          nessuna info sulla SIM installata in questo device da Once
        </span>
      </div>
      <w-card class="px2">
        <span class="title2 mb2">Location</span>
        <w-list :items="stationStore.state.location" class="title3 py2">
          <template #item="{ item }"><span class="text-bold mr4" v-if="item.value">{{ item.label }}: </span>
            <div class="spacer"></div>
            <span class=""> {{ item.value }}</span>
          </template>
        </w-list>
      </w-card>
    </div>

    <div class="spacer box fill-height"></div>
    <div class="smu-hide d-flex">
      <MapComponent v-if="stationStore.state &&
        stationStore.state.station &&
        stationStore.state.station.info &&
        stationStore.state.station.info.coordinates &&
        stationStore.state.station.info.coordinates.length > 0
      " :long="getCoordinates(stationStore.state.station.info.coordinates).long"
        :lat="getCoordinates(stationStore.state.station.info.coordinates).lat" />
    </div>
    <div class="smd-hide xs8 ">
      <MapComponent v-if="stationStore.state &&
        stationStore.state.station &&
        stationStore.state.station.info &&
        stationStore.state.station.info.coordinates &&
        stationStore.state.station.info.coordinates.length > 0
      " :long="getCoordinates(stationStore.state.station.info.coordinates).long"
        :lat="getCoordinates(stationStore.state.station.info.coordinates).lat" />
    </div>
    <!-- Actions buttons above tabs -->
    <w-flex class="mt2 align-center justify-space-evenly actions-bar">

      <!-- Left: RTK -->
      <div class="actions-bar__item">
        <w-button lg @click="startRtkEvaluation()">Run RTK Evaluation</w-button>
      </div>

      <!-- Center: idle control -->
      <div class="idle-control-slot actions-bar__item">

        <!-- PAUSE scenario: state active -->
        <template v-if="stationStore.state.station && getInfoByState(stationStore.state.station.state).id == baseStationStates.active">
          <span v-if="commandInFlight === 'SEND_TO_SLEEP'" class="idle-badge idle-badge--pausing">
            <span class="idle-badge__dot"></span>
            Pausing…
          </span>
          <w-button lg @click="sendToSleep()" title="Manda la base station in stato idle">
            <w-icon class="mr1">mdi mdi-pause</w-icon> Pause Base Station
          </w-button>
          <div v-if="stationStore.state.lastCommand['SEND_TO_SLEEP']" class="idle-feedback">
            {{ stationStore.state.lastCommand['SEND_TO_SLEEP'].commandSent ? 'inviato' : 'errore' }}
            <span v-if="stationStore.state.lastCommand['SEND_TO_SLEEP'].statusHook"> · {{ stationStore.state.lastCommand['SEND_TO_SLEEP'].statusHook }}</span>
          </div>
        </template>

        <!-- RESUME scenario: state notActive -->
        <template v-if="isAdmin && stationStore.state.station && getInfoByState(stationStore.state.station.state).id != baseStationStates.active">
          <span v-if="stationStore.state.lastCommand['SEND_TO_SLEEP']" class="idle-badge idle-badge--idle">
            <span class="idle-badge__dot"></span>
            Idle by Manual Action
          </span>
          <span v-else-if="commandInFlight === 'WAKE_UP'" class="idle-badge idle-badge--connecting">
            <span class="idle-badge__spinner"></span>
            Connecting…
          </span>
          <w-button lg @click="wakeUp()" title="Esci dallo stato idle">
            <w-icon class="mr1">mdi mdi-play</w-icon> Resume Base Station
          </w-button>
          <div v-if="stationStore.state.lastCommand['WAKE_UP']" class="idle-feedback">
            {{ stationStore.state.lastCommand['WAKE_UP'].commandSent ? 'inviato' : 'errore' }}
            <span v-if="stationStore.state.lastCommand['WAKE_UP'].statusHook"> · {{ stationStore.state.lastCommand['WAKE_UP'].statusHook }}</span>
          </div>
        </template>

      </div>


    </w-flex>

    <!-- RTK Evaluation overlay -->
    <w-overlay v-model="rtkEval.show" :persistent="true" :persistent-no-animation="false" :opacity="0.3" class="rtk-overlay">
      <div class="rtk-card">
        <button class="rtk-card__close" @click="closeRtkOverlay()">
          <w-icon>mdi mdi-close</w-icon>
        </button>
        <div class="rtk-card__title">RTK Evaluation</div>

        <!-- RUNNING / starting state -->
        <div v-if="rtkEval.status === 'RUNNING' || rtkEval.status === null" class="rtk-card__loading">
          <w-progress circle :model-value="undefined" size="3em" class="mb2"></w-progress>
          <div v-if="rtkEval.completionPercentage > 0">{{ rtkEval.completionPercentage }}% completed</div>
          <div v-else>Starting evaluation...</div>
        </div>

        <!-- ERROR state -->
        <w-alert v-if="rtkEval.status === 'ERROR'" class="error mt2">
          {{ rtkEval.error || 'Evaluation failed' }}
        </w-alert>

        <!-- COMPLETED state -->
        <div v-if="rtkEval.status === 'COMPLETED' && rtkEval.result">
          <div class="rtk-global-row">
            <span class="rtk-global-row__score">{{ (rtkEval.result.globalScore * 100).toFixed(1) }}%</span>
            <span class="rtk-global-row__sep">—</span>
            <span :class="['rtk-global-row__level', 'rtk-level--' + rtkEval.result.level]">
              {{ rtkEval.result.level }}
            </span>
            <span class="rtk-global-row__label">Global Score</span>
          </div>

          <div class="rtk-section-label">Sub-scores</div>
          <div class="rtk-sub-grid">
            <div v-for="(val, key) in rtkEval.result.subScores" :key="key" class="rtk-field-row">
              <span class="rtk-field-row__label">{{ formatKey(key) }}</span>
              <span class="rtk-field-row__val">{{ (val * 100).toFixed(1) }}%</span>
              <button
                class="rtk-copy-btn"
                :class="{ 'rtk-copy-btn--done': fieldCopied['sub_' + key] }"
                :title="fieldCopied['sub_' + key] ? 'Copiato!' : 'Copia valore'"
                @click="copyField((val * 100).toFixed(1) + '%', 'sub_' + key)"
              >
                <w-icon>{{ fieldCopied['sub_' + key] ? 'mdi mdi-check' : 'mdi mdi-content-copy' }}</w-icon>
              </button>
            </div>
          </div>

          <div class="rtk-section-label">Raw Measures</div>
          <div class="rtk-measures-list">
            <div v-for="item in rtkMeasureItems" :key="item.label" class="rtk-measure-row">
              <span class="rtk-measure-row__label">{{ item.label }}</span>
              <span class="rtk-measure-row__val">{{ item.value }}</span>
              <button
                class="rtk-copy-btn"
                :class="{ 'rtk-copy-btn--done': fieldCopied['raw_' + item.label] }"
                :title="fieldCopied['raw_' + item.label] ? 'Copiato!' : 'Copia valore'"
                @click="copyField(String(item.value), 'raw_' + item.label)"
              >
                <w-icon>{{ fieldCopied['raw_' + item.label] ? 'mdi mdi-check' : 'mdi mdi-content-copy' }}</w-icon>
              </button>
            </div>
          </div>

          <div class="rtk-card__footer">
            <button class="rtk-copy-all-btn" :class="{ 'rtk-copy-all-btn--done': rtkCopied }" @click="copyRtkResult()">
              <w-icon class="mr1">{{ rtkCopied ? 'mdi mdi-check' : 'mdi mdi-content-copy' }}</w-icon>
              {{ rtkCopied ? 'Copied' : 'Copy Text' }}
            </button>
          </div>
        </div>
      </div>
    </w-overlay>
  </w-flex>
  <div class="spacer my5"></div>
  <!-- Mobile layout: collapsible sections -->
  <div class="mdu-hide">
    <div class="px3">
      <CollapsibleComponent :items="items">
        <template v-slot="{ }">
          <p class="text-right title3 xs12 under mb2"><router-link
              :to="'/monitoring/' + getPathBaseStation() + '/graph'">Open
              graph<w-icon>mdi mdi-arrow-right</w-icon></router-link></p>
          <HistoryComponent :history="stationStore.state.history"
            :connectionLastStop="stationStore.state.station.connectionLastStop"
            :connectionLastStart="stationStore.state.station.connectionLastStart"
            :connectionLastMeta="stationStore.state.station.connectionLastMeta"
            :lastRefresh="stationStore.state.lastRefresh" />
        </template>
      </CollapsibleComponent>
    </div>
    <div class="spacer mt7"></div>
    <div class="px3">
      <span class="title2">Robots</span>
      <RobotsList :robots="stationStore.state.robots" />
    </div>
    <template v-if="isAdmin">
      <div class="spacer mt7"></div>
      <div class="px3">
        <CollapsibleComponent :items="georefCollapsibleItems">
          <template v-slot="{ }">
            <div class="georef-tab-actions px3 mb3">
              <w-button v-if="!georefConfirm" lg @click="requestGeoref()" title="Avvia georeferenziazione">
                <w-icon class="mr1">mdi mdi-crosshairs-gps</w-icon> Run Georef
              </w-button>
              <div v-else class="georef-confirm-row">
                <span class="georef-confirm-label">Confirm Georef?</span>
                <w-button sm bg-color="success" @click="confirmGeoref()">
                  <w-icon class="mr1">mdi mdi-check</w-icon> Yes
                </w-button>
                <w-button sm @click="cancelGeoref()">
                  <w-icon class="mr1">mdi mdi-close</w-icon> No
                </w-button>
              </div>

            </div>
            <GeoreferencingHistory />
          </template>
        </CollapsibleComponent>
      </div>
    </template>
  </div>
  <!-- Desktop layout: tabs -->
  <div class="smd-hide">
    <w-tabs v-model="activeTab" :items="tabs" :fill-bar="true">
      <template #[`item-title.1`]="{ item }">
        <span class="mr1">{{ item.title }}</span>
        <w-tag :class="ntripStateInfo.class" sm>{{ ntripStateInfo.name }}</w-tag>
      </template>
      <template #[`item-title.2`]="{ item }">
        <span class="mr1">{{ item.title }}</span>
        <span class="green ml1">{{ connectedRobots }}●</span>
        <span class="grey ml1">{{ disconnectedRobots }}○</span>
      </template>
      <template #[`item-title.3`]="{ item }">
        <span class="mr1">{{ item.title }}</span>
        <w-badge v-if="georeferencingStore.state.count > 0" inline sm>
          {{ georeferencingStore.state.count }}
        </w-badge>
      </template>
      <template #[`item-content.1`]>
        <p class="text-right title3 xs12 under mb2"><router-link
            :to="'/monitoring/' + getPathBaseStation() + '/graph'">Open
            graph<w-icon>mdi mdi-arrow-right</w-icon></router-link></p>
        <HistoryComponent :history="stationStore.state.history"
          :connectionLastStop="stationStore.state.station.connectionLastStop"
          :connectionLastStart="stationStore.state.station.connectionLastStart"
          :connectionLastMeta="stationStore.state.station.connectionLastMeta"
          :lastRefresh="stationStore.state.lastRefresh" />
      </template>
      <template #[`item-content.2`]>
        <RobotsList :robots="stationStore.state.robots" />
      </template>
      <template #[`item-content.3`]>
        <div v-if="isAdmin" class="georef-tab-actions">
          <w-button v-if="!georefConfirm" lg @click="requestGeoref()" title="Avvia georeferenziazione">
            <w-icon class="mr1">{{ georeferencingStore.state.hasInProgress ? 'mdi mdi-refresh' : 'mdi mdi-crosshairs-gps' }}</w-icon>
            {{ georeferencingStore.state.hasInProgress ? 'Retry Georef' : 'Run Georef' }}
          </w-button>
          <div v-else class="georef-confirm-row">
            <span class="georef-confirm-label">Confirm Georef?</span>
            <w-button sm bg-color="success" @click="confirmGeoref()">
              <w-icon class="mr1">mdi mdi-check</w-icon> Yes
            </w-button>
            <w-button sm @click="cancelGeoref()">
              <w-icon class="mr1">mdi mdi-close</w-icon> No
            </w-button>
          </div>
          <div v-if="georefToast.visible" :class="['georef-toast', georefToast.isError ? 'georef-toast--error' : 'georef-toast--info']">
            <w-icon sm class="mr1">{{ georefToast.isError ? 'mdi mdi-alert-circle-outline' : 'mdi mdi-check' }}</w-icon>
            {{ georefToast.message }}
          </div>
        </div>
        <GeoreferencingHistory />
      </template>
    </w-tabs>
  </div>
</template>
<template v-else>
  <w-progress
          class="ma1"
          circle
          :model-value="undefined"
          size="6em"
        ></w-progress>
</template>
</template>
<script>
import { store } from "@/utils/store";
import { stationStore } from "../store/monitorig";
import { ref, computed, watch, onMounted, onUnmounted } from "vue";
import { useRoute } from "vue-router";
import "@mdi/font/css/materialdesignicons.min.css";
import { defineAsyncComponent } from "vue";
import { timeformatLoc } from "@/utils/time-formatter";
import { optionsStore } from "@/store/options";
import router from "@/router";
import errorManager from "@/modules/errors/error-services/error-manager";
import { reactive } from "vue";
import { ErrorMessage } from "@/models/ErrorMessage";
import StateInfo from '../components/StateInfo.vue';
import { getInfoByState, getInfoByGeorefState, getInfoByFirmwareState, statusInfoBaseStation, statusInfoGeoref } from '@/utils/status';
import { baseStationStates } from "@/utils/constants";
import { groupStore } from '@/modules/label-group/store/label-group';
import RtkAnalyzerService from '../RtkAnalyzerService.js';
import { georeferencingStore } from "../store/georeferencing";


const monitoring_details = window.__env?.defaults?.monitoring_details || {
  "auto_refresh_wait_sec": 30,
  "auto_refresh_enabled": false,
  "manual_refresh_enabled": false
};

const auto_refresh_wait = (monitoring_details?.auto_refresh_wait_sec || 50) * 1000;
const auto_refresh_enabled = !!monitoring_details?.auto_refresh_enabled;
const manual_refresh_enabled = !!monitoring_details?.manual_refresh_enabled;
// Async component without options
const MapComponent = defineAsyncComponent(() => import("../components/Map"));
const HistoryComponent = defineAsyncComponent(() =>
  import("../components/HistoryComponent")
);
const RobotsList = defineAsyncComponent(() =>
  import("../components/RobotsList")
);

const CollapsibleComponent = defineAsyncComponent(() =>
  import("../components/CollapsibleComponent")
);
const GeoreferencingHistory = defineAsyncComponent(() =>
  import("../components/GeoreferencingHistory")
);

const labelGroups = computed(() =>
  stationStore.state.stat.filter(item => item.label === 'Label Groups')
);

const otherStats = computed(() =>
  stationStore.state.stat.filter(item => item.label !== 'Label Groups' && item.value)
);


export default {
  components: {
    MapComponent,
    HistoryComponent,
    RobotsList,
    CollapsibleComponent,
    StateInfo,
    GeoreferencingHistory
  },
  setup: () => {
    const route = useRoute();
    const now = ref(new Date().getTime() / 1000);
    const commandPending = ref(false);
    const commandInFlight = ref(null);
    const userId = ref()
    var overlay = reactive({
      valid: false,
      show: false,
      sent: false,
      loading: false,
      error: null
    })
    var timer = null;
    const rtkEval = reactive({
      show: false,
      status: null,
      completionPercentage: 0,
      result: null,
      error: null,
    });
    let rtkTimer = null;
    const rtkCopied = ref(false);
    let rtkCopiedTimer = null;
    const fieldCopied = reactive({});
    const fieldCopiedTimers = {};
    const isMounted = ref(false);
    const coordinates = computed(() =>
      getCoordinates(stationStore.state.station.info.coordinates)
    );
    const rtkMeasureItems = computed(() => {
      if (!rtkEval.result?.rawMeasures) return [];
      const m = rtkEval.result.rawMeasures;
      return [
        { label: 'Total Satellites', value: m.totalSatelliteCount },
        { label: 'GPS', value: m.gpsSatelliteCount },
        { label: 'Galileo', value: m.galileoSatelliteCount },
        { label: 'GLONASS', value: m.glonassSatelliteCount },
        { label: 'BeiDou', value: m.beidouSatelliteCount },
        { label: 'Avg SNR (dB)', value: m.averageSignalNoiseRatioInDb?.toFixed(2) },
        { label: 'Avg Frequency (Hz)', value: m.averageFrequencyInHz?.toFixed(4) },
        { label: 'Avg Msg Interval (ms)', value: m.averageMessageIntervalMillis },
        { label: 'Observation Period (s)', value: m.observationPeriodSeconds },
        { label: 'Has Metadata', value: m.hasMetadata ? 'Yes' : 'No' },
        { label: 'Major Constellations', value: m.majorConstellationCount },
      ].filter(item => item.value != null);
    });
    const storeState = computed(() => stationStore.getState());
    const status = computed(() => {
      return stationStore.getState() && stationStore.getState().station
        ? stationStore.getState().station.state
        : baseStationStates.notActive;
    });
    const items = ref([
      { title: 'History', active: false, height: null },
    ]);
    const georefCollapsibleItems = ref([
      { title: 'Georeferencing History', active: false, height: null },
    ]);
    const isAdmin = computed(() => store.currentUser && store.currentUser.roles && store.currentUser.roles.includes('ADMIN'));
    const activeTab = ref(0);
    const tabs = computed(() => {
      const t = [
        { title: 'History' },
        { title: 'Robots' },
      ];
      if (isAdmin.value) {
        t.push({ title: 'Georeferencing History' });
      }
      return t;
    });
    const connectedRobots = computed(() =>
      stationStore.state.robots ? stationStore.state.robots.filter(r => r.status === 'Connected').length : 0
    );
    const disconnectedRobots = computed(() =>
      stationStore.state.robots ? stationStore.state.robots.length - connectedRobots.value : 0
    );

    // ── 3 dimensioni di stato ────────────────────────────
    const ntripStateInfo = computed(() =>
      getInfoByState(stationStore.state.station?.state)
    );
    const georefStateInfo = computed(() =>
      getInfoByGeorefState(stationStore.state.computedGeorefState)
    );
    const firmwareStateInfo = computed(() => {
      const info = stationStore.state.firmwareInfo;
      if (!info) return null;
      const state = info.state;
      if (state !== 'AUTO_UPDATE_DISABLED' && info.expectedVersion == null) {
        return getInfoByFirmwareState('UNKNOWN');
      }
      return getInfoByFirmwareState(state ?? null);
    });
    const firmwareVersion = computed(() =>
      stationStore.state.firmwareInfo?.version ?? null
    );
    const firmwareExpectedVersion = computed(() =>
      stationStore.state.firmwareInfo?.expectedVersion ?? null
    );
    const firmwareError = computed(() =>
      stationStore.state.firmwareInfo?.error ?? null
    );

    function formatKey(key) {
      return key.replace(/([A-Z])/g, ' $1').replace(/^./, s => s.toUpperCase());
    }

    async function sendToSleep() {
      if (commandPending.value) return;
      commandPending.value = true;
      commandInFlight.value = 'SEND_TO_SLEEP';
      try {
        await stationStore.sendCommand('SEND_TO_SLEEP');
        refresh();
      } catch (err) {
        console.error('Failed to send sleep command:', err);
        commandInFlight.value = null;
      } finally {
        commandPending.value = false;
      }
    }

    async function wakeUp() {
      if (commandPending.value) return;
      commandPending.value = true;
      commandInFlight.value = 'WAKE_UP';
      try {
        await stationStore.sendCommand('WAKE_UP');
        refresh();
      } catch (err) {
        console.error('Failed to send wake up command:', err);
        commandInFlight.value = null;
      } finally {
        commandPending.value = false;
      }
    }

    const georefToast = reactive({ visible: false, isError: false, message: '' });
    let georefToastTimer = null;

    function showGeorefToast(message, isError, durationMs) {
      clearTimeout(georefToastTimer);
      georefToast.visible = true;
      georefToast.isError = isError;
      georefToast.message = message;
      georefToastTimer = setTimeout(() => { georefToast.visible = false; }, durationMs);
    }

    async function sendGeoref() {
      if (commandPending.value) return;
      commandPending.value = true;
      try {
        const georefCountAtSend = georeferencingStore.state.count;
        await stationStore.sendCommand('GEOREF', { georefCountAtSend });
        refresh();
        georeferencingStore.state.tasksTrigger++;
        const cmd = stationStore.state.lastCommand['GEOREF'];
        if (cmd?.statusHook) showGeorefToast(cmd.statusHook, false, 5000);
      } catch (err) {
        console.error('Failed to send georef command:', err);
        const base = err?.statusHook || 'Command failed.';
        const detail = err?.errDetail;
        const msg = detail && !base.includes(detail) ? `${base} · ${detail}` : base;
        showGeorefToast(msg, true, 5000);
      } finally {
        commandPending.value = false;
      }
    }

    const georefConfirm = ref(false);
    let georefConfirmTimer = null;

    function requestGeoref() {
      georefConfirm.value = true;
      clearTimeout(georefConfirmTimer);
      clearTimeout(georefToastTimer);
      georefConfirmTimer = setTimeout(() => { georefConfirm.value = false; }, 4000);
    }

    function confirmGeoref() {
      clearTimeout(georefConfirmTimer);
      georefConfirm.value = false;
      sendGeoref();
    }

    function cancelGeoref() {
      clearTimeout(georefConfirmTimer);
      georefConfirm.value = false;
    }

    async function pollRtkEvaluation() {
      const mountpoint = stationStore.state.station.baseStation;
      try {
        const { data } = await RtkAnalyzerService.evaluate(mountpoint);
        rtkEval.status = data.status;
        rtkEval.completionPercentage = data.completionPercentage;
        rtkEval.result = data.result;
        rtkEval.error = data.error;
        if (data.status === 'RUNNING') {
          rtkTimer = setTimeout(pollRtkEvaluation, 3000);
        }
      } catch (err) {
        rtkEval.status = 'ERROR';
        rtkEval.error = err.message || 'Evaluation failed';
      }
    }

    function startRtkEvaluation() {
      rtkEval.show = true;
      rtkEval.status = null;
      rtkEval.completionPercentage = 0;
      rtkEval.result = null;
      rtkEval.error = null;
      pollRtkEvaluation();
    }

    function closeRtkOverlay() {
      clearTimeout(rtkTimer);
      rtkTimer = null;
      rtkEval.show = false;
    }

    function buildRtkResultText() {
      const r = rtkEval.result;
      if (!r) return '';
      const lines = [
        `RTK Evaluation Result`,
        `Global Score: ${(r.globalScore * 100).toFixed(1)}% — ${r.level}`,
        ``,
        `Sub-scores:`,
        ...Object.entries(r.subScores || {}).map(([k, v]) => `  ${formatKey(k)}: ${(v * 100).toFixed(1)}%`),
        ``,
        `Raw Measures:`,
      ];
      const m = r.rawMeasures || {};
      if (m.totalSatelliteCount != null) lines.push(`  Total Satellites: ${m.totalSatelliteCount}`);
      if (m.gpsSatelliteCount != null) lines.push(`  GPS: ${m.gpsSatelliteCount}`);
      if (m.galileoSatelliteCount != null) lines.push(`  Galileo: ${m.galileoSatelliteCount}`);
      if (m.glonassSatelliteCount != null) lines.push(`  GLONASS: ${m.glonassSatelliteCount}`);
      if (m.beidouSatelliteCount != null) lines.push(`  BeiDou: ${m.beidouSatelliteCount}`);
      if (m.averageSignalNoiseRatioInDb != null) lines.push(`  Avg SNR (dB): ${m.averageSignalNoiseRatioInDb.toFixed(2)}`);
      if (m.averageFrequencyInHz != null) lines.push(`  Avg Frequency (Hz): ${m.averageFrequencyInHz.toFixed(4)}`);
      if (m.averageMessageIntervalMillis != null) lines.push(`  Avg Msg Interval (ms): ${m.averageMessageIntervalMillis}`);
      if (m.observationPeriodSeconds != null) lines.push(`  Observation Period (s): ${m.observationPeriodSeconds}`);
      if (m.hasMetadata != null) lines.push(`  Has Metadata: ${m.hasMetadata ? 'Yes' : 'No'}`);
      if (m.majorConstellationCount != null) lines.push(`  Major Constellations: ${m.majorConstellationCount}`);
      return lines.join('\n');
    }

    async function writeClipboard(text) {
      try { await navigator.clipboard.writeText(text); return true; } catch { return false; }
    }

    async function copyRtkResult() {
      if (!await writeClipboard(buildRtkResultText())) return;
      clearTimeout(rtkCopiedTimer);
      rtkCopied.value = true;
      rtkCopiedTimer = setTimeout(() => { rtkCopied.value = false; }, 2000);
    }

    async function copyField(value, fieldKey) {
      if (!await writeClipboard(value)) return;
      clearTimeout(fieldCopiedTimers[fieldKey]);
      fieldCopied[fieldKey] = true;
      fieldCopiedTimers[fieldKey] = setTimeout(() => { delete fieldCopied[fieldKey]; }, 1500);
    }

    function refresh() {
      clearInterval(timer);
      stationStore
        .refresh(getPathBaseStation())
        .then(() => {
          const cleared = stationStore.clearStaleIdleCommands();
          if (cleared) commandInFlight.value = null;
          if (isAdmin.value && stationStore.getState().station && stationStore.getState().station.imei) {
            georeferencingStore.loadHistory(stationStore.getState().station.imei).then(() => {
              stationStore.clearStaleGeorefCommand(georeferencingStore.state.count);
              georeferencingStore.state.tasksTrigger++;
            });
          }
        })
        .finally(
          establishRefresh()
        );
    }

    async function loadLabelGroup(label) {
      groupStore.state.label = label;
      groupStore.getImeiByLabel(label).then(()=>{
        console.log("complete as "+ groupStore.imei);
        router.push("/label-group");})
    }

    function establishRefresh() {
      clearInterval(timer);
      if (auto_refresh_enabled && router && router.currentRoute.value.name == "MonitoringStation") {
        timer = setInterval(async () => {
          await stationStore.refresh(getPathBaseStation());
          const cleared = stationStore.clearStaleIdleCommands();
          if (cleared) commandInFlight.value = null;
          if (isAdmin.value && stationStore.getState().station && stationStore.getState().station.imei) {
            await georeferencingStore.loadHistory(stationStore.getState().station.imei);
            stationStore.clearStaleGeorefCommand(georeferencingStore.state.count);
          }
        }, auto_refresh_wait);
      }
    }

    function getCoordinates(state) {
      let coordinates = [NaN, NaN];
      if (state) {
        coordinates = state;
      }
      return {
        //Tobe a method
        long: Number(coordinates[1]),
        lat: Number(coordinates[0]),
      };
    }
    function getPathBaseStation() {
      return route.params.basestation;
    }

    function backToThings(imei) {
      // router system must be changed to retrive path variables

      return imei;
    }

    function changeInstaller(userId) {
      overlay.loading = true;
      overlay.loading = stationStore.changeInstaller(userId).then(() => {
        console.log("COMPLETE change");
        refresh()
        overlay.show = false
      }
      ).catch((er) => {
        console.log("ERROR");
        errorManager.manage(er, errorManager.caseNotFound(() => {
          var error = errorManager.error(new ErrorMessage(er, "Unknown User Id", 404));
          overlay.error = error
        }), errorManager.defaultCase(() => {
          var error = errorManager.error(er);
          overlay.error = error;
        })
        )
      })
        .finally(() => { return Promise.resolve(false) });
    }
    async function mount() {
      let pathId = getPathBaseStation();
      stationStore.setStation({
        info: { coordinates: [] },
        connectionsHistory: [],
        robot: [],
      });
      isMounted.value = await stationStore.refresh(pathId).then(async () => {
        //track error here and delay further refresh or notify and do a manuali
        establishRefresh()
        let log = await stationStore.loadSimDetails(stationStore.getState().station.imei)
        console.log(log)
        if (store.currentUser && store.currentUser.roles && store.currentUser.roles.includes('ADMIN')) {
          georeferencingStore.loadHistory(stationStore.getState().station.imei);
        }
        return Promise.resolve(true);
      });
    }

    onMounted(async () => await mount());

    watch(() => route.params.basestation, async (newVal, oldVal) => {
      if (newVal !== oldVal) {
        clearInterval(timer);
        stationStore.resetCommands();
        commandInFlight.value = null;
        await mount();
      }
    });

    onUnmounted(() => {
      clearInterval(timer);
      clearTimeout(rtkTimer);
      clearTimeout(rtkCopiedTimer);
      Object.values(fieldCopiedTimers).forEach(clearTimeout);
      clearTimeout(georefConfirmTimer);
      georeferencingStore.reset();
      stationStore.resetCommands();
      commandInFlight.value = null;
    });

    return {
      baseStationStates,
      getInfoByState,
      statusInfoBaseStation,
      manual_refresh_enabled,
      items,
      stationStore,
      // stat,
      history,
      location,
      coordinates,
      opacity: 0.3,
      persistent: true,
      persistentNoAnimation: false,
      getPathBaseStation,
      status,
      storeState,
      isMounted,
      getCoordinates,
      refresh,
      //time
      optionsStore,
      timeformatLoc,
      now,
      overlay,
      validators: {
        required: value => !!value || 'This field is required',
        number: value => /^\d+$/.test(value) || 'Insert the numeric code that identify the user id'
      },
      changeInstaller,
      userId,
      store,
      loadLabelGroup,
      otherStats,
      labelGroups,
      backToThings,
      rtkEval,
      rtkMeasureItems,
      startRtkEvaluation,
      closeRtkOverlay,
      copyRtkResult,
      rtkCopied,
      fieldCopied,
      copyField,
      formatKey,
      activeTab,
      tabs,
      isAdmin,
      connectedRobots,
      disconnectedRobots,
      georeferencingStore,
      georefCollapsibleItems,
      statusInfoGeoref,
      sendToSleep,
      wakeUp,
      sendGeoref,
      georefToast,
      georefConfirm,
      requestGeoref,
      confirmGeoref,
      cancelGeoref,
      commandPending,
      commandInFlight,
      ntripStateInfo,
      georefStateInfo,
      firmwareStateInfo,
      firmwareVersion,
      firmwareExpectedVersion,
      firmwareError,
      getInfoByGeorefState,
      getInfoByFirmwareState,
    };
  },
};
</script>

<style scoped>
/* ── Idle control slot ───────────────────────────────── */
.idle-control-slot {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  min-width: 260px;
}
.idle-control-spacer {
  min-width: 160px;
}

/* badges */
.idle-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: .06em;
  padding: 4px 12px;
  border-radius: 20px;
  user-select: none;
}
.idle-badge--active   { background: #e6f9ed; color: #27ae60; border: 1px solid #a8dfc0; }
.idle-badge--pausing  { background: #fff7e0; color: #e6a817; border: 1px solid #f5d87a; }
.idle-badge--idle     { background: #eef0ff; color: #5c6bc0; border: 1px solid #b3b9f0; }
.idle-badge--connecting { background: #e3f2fd; color: #1565c0; border: 1px solid #90caf9; }
.idle-badge--georef-run { background: #f3e5f5; color: #6a1b9a; border: 1px solid #ce93d8; }

.idle-badge__dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: currentColor;
  flex-shrink: 0;
}

@keyframes idle-spin { to { transform: rotate(360deg); } }
.idle-badge__spinner {
  width: 10px;
  height: 10px;
  border: 2px solid #90caf9;
  border-top-color: #1565c0;
  border-radius: 50%;
  animation: idle-spin .7s linear infinite;
  flex-shrink: 0;
}
.idle-badge__spinner--georef {
  border-color: #ce93d8;
  border-top-color: #6a1b9a;
}

/* feedback */
.idle-feedback {
  font-size: 11px;
  color: #666;
  text-align: center;
  background: #f7f8fb;
  border: 1px solid #e8eaef;
  border-radius: 6px;
  padding: 5px 14px;
  min-width: 220px;
  animation: idle-feedback-in .25s ease;
}
@keyframes idle-feedback-in {
  from { opacity: 0; transform: translateY(-4px); }
  to   { opacity: 1; transform: translateY(0); }
}

/* ── Actions bar responsive ──────────────────────────── */
.actions-bar__item {
  display: flex;
  flex-direction: column;
  align-items: center;
}

@media (max-width: 600px) {
  .actions-bar {
    flex-direction: column !important;
    align-items: stretch !important;
    gap: 12px;
  }
  .actions-bar__item {
    width: 100%;
    align-items: center;
  }
  .idle-control-slot {
    min-width: unset;
    width: 100%;
  }
  .stato-row {
    flex-wrap: wrap;
    row-gap: 2px;
  }
  .stato-dim {
    flex: 1 1 100%;
  }
  .stato-badge {
    margin-left: 24px;
  }
}

/* ── Stati Antenna card ──────────────────────────────── */
.stati-card {
  border: 1px solid #c5cae9;
  border-radius: 8px;
  overflow: visible; /* tooltip must escape card boundaries */
  margin-bottom: 4px;
  position: relative;
}
.stati-card__header {
  display: flex;
  align-items: center;
  padding: 6px 10px;
  background: #e8eaf6;
  border-bottom: 1px solid #c5cae9;
  border-radius: 8px 8px 0 0;
}
.stati-card__body {
  padding: 6px 10px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.stato-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 2px 0;
}
.stato-dim {
  display: flex;
  align-items: center;
  gap: 4px;
  white-space: nowrap;
}
.stati-card__info-icon {
  position: relative;
  z-index: 10100;
  font-weight: normal;
  color: unset;
}
.stato-sep {
  border: none;
  border-top: 1px dashed #e0e3eb;
  margin: 2px 0;
}
.stato-badge {
  display: inline-flex;
  align-items: center;
  border-radius: 12px;
  white-space: nowrap;
}
/* ── End stati card ──────────────────────────────────── */

/* ── RTK overlay z-index (above leaflet controls z-index:1000) ── */
:deep(.rtk-overlay) { z-index: 10200 !important; }

/* ── RTK card ────────────────────────────────────────── */
.rtk-card {
  background: #fff;
  border-radius: 12px;
  border: 1px solid #e0e3eb;
  width: 480px;
  max-width: calc(100vw - 32px);
  max-height: calc(100vh - 64px);
  overflow-y: auto;
  padding: 20px 22px 18px;
  position: relative;
}
.rtk-card__close {
  position: absolute;
  top: 10px;
  right: 12px;
  background: none;
  border: none;
  cursor: pointer;
  color: #9e9e9e;
  line-height: 1;
  padding: 2px;
  border-radius: 4px;
}
.rtk-card__close:hover { color: #424242; background: #f5f5f5; }
.rtk-card__title {
  font-size: 16px;
  font-weight: 600;
  color: #212121;
  margin-bottom: 16px;
  padding-right: 28px;
}
.rtk-card__loading { text-align: center; padding: 20px 0; }
.rtk-card__footer {
  margin-top: 16px;
  padding-top: 12px;
  border-top: 1px solid #eeeeee;
  display: flex;
  justify-content: flex-end;
}

/* global score row */
.rtk-global-row {
  display: flex;
  align-items: center;
  gap: 8px;
  background: #f5f6fa;
  border-radius: 8px;
  padding: 10px 14px;
  margin-bottom: 16px;
}
.rtk-global-row__score { font-size: 20px; font-weight: 600; color: #212121; }
.rtk-global-row__sep   { color: #bdbdbd; }
.rtk-global-row__label { font-size: 12px; color: #9e9e9e; margin-left: 4px; }
.rtk-global-row__level {
  font-size: 12px;
  font-weight: 600;
  padding: 3px 10px;
  border-radius: 20px;
}
.rtk-level--excellent { background: #e8f5e9; color: #2e7d32; }
.rtk-level--good      { background: #e3f2fd; color: #1565c0; }
.rtk-level--fair      { background: #fff8e1; color: #e65100; }
.rtk-level--poor      { background: #fce4ec; color: #c62828; }

/* section label */
.rtk-section-label {
  font-size: 13px;
  font-weight: 600;
  color: #424242;
  margin-bottom: 8px;
  margin-top: 16px;
  padding-bottom: 4px;
  border-bottom: 1px solid #e0e0e0;
}

/* sub-scores grid */
.rtk-sub-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 6px;
  margin-bottom: 4px;
}
.rtk-field-row {
  display: flex;
  align-items: center;
  background: #f5f6fa;
  border-radius: 6px;
  padding: 6px 10px;
  gap: 6px;
}
.rtk-field-row__label {
  font-size: 12px;
  color: #757575;
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.rtk-field-row__val {
  font-size: 13px;
  font-weight: 600;
  color: #212121;
  white-space: nowrap;
}

/* measures list */
.rtk-measures-list {
  background: #f5f6fa;
  border-radius: 8px;
  overflow: hidden;
}
.rtk-measure-row {
  display: flex;
  align-items: center;
  padding: 6px 12px;
  gap: 8px;
  border-bottom: 1px solid #eeeeee;
}
.rtk-measure-row:last-child { border-bottom: none; }
.rtk-measure-row__label { font-size: 13px; color: #757575; flex: 1; }
.rtk-measure-row__val   { font-size: 13px; font-weight: 600; color: #212121; }

/* copy buttons */
.rtk-copy-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  flex-shrink: 0;
  background: none;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  color: #bdbdbd;
  font-size: 14px;
  transition: color .15s, background .15s;
  padding: 0;
}
.rtk-copy-btn:hover { color: #1565c0; background: #e3f2fd; }
.rtk-copy-btn--done { color: #2e7d32 !important; }

.rtk-copy-all-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 7px 18px;
  border-radius: 6px;
  border: 1px solid #c5cae9;
  background: #fff;
  color: #424242;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: background .15s, color .15s;
}
.rtk-copy-all-btn:hover { background: #f5f6fa; }
.rtk-copy-all-btn--done { border-color: #a8dfc0; color: #2e7d32 !important; }
/* ─────────────────────────────────────────────────────── */

/* ── Georef tab actions bar ─────────────────────────── */
.georef-tab-actions {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 0 8px;
  border-bottom: 1px solid #eeeeee;
  margin-bottom: 12px;
  flex-wrap: wrap;
}
/* ─────────────────────────────────────────────────────── */

/* ── Georef toast ────────────────────────────────────── */
.georef-toast {
  display: inline-flex;
  align-items: center;
  padding: 5px 12px;
  border-radius: 6px;
  font-size: 12px;
  border: 1px solid;
  animation: idle-feedback-in .2s ease;
}
.georef-toast--error {
  background: #fde8e8;
  border-color: #f0a8a8;
  color: #b71c1c;
}
.georef-toast--info {
  background: #f5f6fa;
  border-color: #c5cae9;
  color: #424242;
}
/* ─────────────────────────────────────────────────────── */

/* ── Georef confirm row ─────────────────────────────── */
.georef-confirm-row {
  display: flex;
  align-items: center;
  gap: 8px;
  animation: idle-feedback-in .2s ease;
}
.georef-confirm-label {
  font-size: 13px;
  font-weight: 600;
  color: #424242;
  white-space: nowrap;
}
/* ─────────────────────────────────────────────────────── */

/* ── End idle control ────────────────────────────────── */

/* ── Firmware version block ─────────────────────────── */
.firmware-version-block {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 2px;
}
.firmware-expected {
  font-size: 13px;
  color: #757575;
  white-space: nowrap;
}
.firmware-expected strong {
  color: #e65100;
  font-weight: 600;
}
.firmware-expected-disabled {
  font-size: 10px;
  color: #bdbdbd;
  font-style: italic;
  white-space: nowrap;
}
.firmware-expected-unknown {
  font-size: 10px;
  color: #e65100;
  font-style: italic;
  white-space: nowrap;
}
.firmware-error-msg {
  font-size: 10px;
  color: #b71c1c;
  white-space: normal;
  word-break: break-word;
  max-width: 200px;
  text-align: right;
}
/* ─────────────────────────────────────────────────────── */

.monitoring-title {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  height: 100%;
}

.back-link {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.v-middle {
  vertical-align: middle;
}

.under {
  text-decoration: underline;
}

.overlays {
  background-color: aliceblue;
}

.right {
  position: relative;
  right: -80%;
}

.top {
  position: relative;
  top: 1%;
}

.icon-button:hover {
  cursor: pointer;
}

.overlay-confirm.disabled {
  background-color: "primary-light3";
}

/* Style the button that is used to open and close the collapsible content */
.collapsible {
  cursor: pointer;

}

.content {
  display: none;
  overflow: hidden;
}

/* Style the collapsible content. Note: hidden by default */


/* 
.mdl-expansion {
   
  &__summary { 
    list-style-type: none;
    
    &::-webkit-details-marker {
      display: none;
    }
    &::before {
  }
    
    &::after {
      display: inline-flex;
      flex-direction: column;
      user-select: none;
      transition: transform 200ms, color 200ms;
    }
    
    &:focus {
      background-color: #EEEEEE;
      
      &::after {
        color: rgba(0, 0, 0, .54);
      }
    }
  }
  
  &__header {
    display: flex;
    flex-direction: column;
    flex-basis: 30%;
  }
  
  &__subheader {
    font-size: .75rem;
  }
  
  &__secondary-content {
    display: flex;
    flex-direction: column;
    font-size: 0.9375rem;
    flex-basis: 30%;
  }

  &__content {
    padding: 20px;
    
    & + .mdl-expansion__actions {
      border-top: 1px solid rgba(0, 0, 0, .12);
    }
  }
  
  &__actions {
    display: flex;
    flex-direction: row-reverse;
    padding-top: 16px;
    padding-bottom: 16px;
  }
  
  &__action {
    margin-right: 8px;
  }
  
  &[open] {
    .mdl-expansion__summary::after {
        transform: rotate(180deg);
    }
  }
  
}

details > summary {
    list-style-type: none;
}



details > summary::before {
  content: 'f142';
} */
</style>
